import { render } from "./index.vue?vue&type=template&id=241a2699"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/online-shop-service-edit/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "241a2699"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('241a2699', __exports__)) {
    api.reload('241a2699', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=241a2699", () => {
    api.rerender('241a2699', render)
  })

}


export default __exports__